(function () {
  const productSlider = () => {
    $(document).ready(function () {
      $(".js-get-section").each(function (index, parent) {
        let parentId = `#${$(parent).attr("id")}`;

        let carousel = document
          .querySelector(parentId)
          .querySelector(`.js-swiper-product-carousel`);

        let scrollBar = document
          .querySelector(parentId)
          .querySelector(`.js-product-carousel-swiper-scrollbar`);

        let prev = document
          .querySelector(parentId)
          .querySelector(`.js-product-carousel-arrow-prev`);

        let next = document
          .querySelector(parentId)
          .querySelector(`.js-product-carousel-arrow-next`);

        // Get breakpoint settings from data attributes
        const parentElement = document.querySelector(parentId);
        const slides0 =
          parseInt(parentElement.getAttribute("data-slides-0")) || 1;
        const slides920 =
          parseInt(parentElement.getAttribute("data-slides-920")) || 2;
        const slides1100 =
          parseInt(parentElement.getAttribute("data-slides-1100")) || 3;
        const slides1200 =
          parseInt(parentElement.getAttribute("data-slides-1200")) || 2;
        const slides1300 =
          parseInt(parentElement.getAttribute("data-slides-1300")) || 3;
        const slides1500 =
          parseInt(parentElement.getAttribute("data-slides-1500")) || 3;
        const slides1800 =
          parseInt(parentElement.getAttribute("data-slides-1800")) || 3;

        // Build breakpoints object with original breakpoints
        const breakpoints = {
          0: { slidesPerView: slides0 },
          920: { slidesPerView: slides920 },
          1100: { slidesPerView: slides1100 },
          1200: { slidesPerView: slides1200 },
          1300: { slidesPerView: slides1300 },
          1500: { slidesPerView: slides1500 },
          1800: { slidesPerView: slides1800 },
        };

        let swiperCarousel = new Swiper(carousel, {
          slidesPerView: slides1800,
          spaceBetween: 8,

          scrollbar: {
            el: scrollBar,
            draggable: true,
          },

          navigation: {
            prevEl: prev,
            nextEl: next,
          },

          breakpoints: breakpoints,
        });

        // Check if both arrows are locked for this specific section
        const navTools = parentElement.querySelector(
          ".product-carousel_nav-tools"
        );
        if (navTools && prev && next) {
          if (
            prev.classList.contains("swiper-button-lock") &&
            next.classList.contains("swiper-button-lock")
          ) {
            navTools.style.display = "none";
          }
        }
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    productSlider();
    document.addEventListener("shopify:section:load", function () {
      productSlider();
    });
  });
})();
